export default "__VITE_ASSET__CMRiKMef__"